import type { PreviewType } from '../../types';
import { selectLayout } from '../../utils/layoutSelector';
import { SessionCard } from './SessionCard';
import { AssignmentCard } from './AssignmentCard';
import { ResourceCard } from './ResourceCard';
import { StudentProgressCard } from './StudentProgressCard';
import { QuestionDraftCard } from './QuestionDraftCard';
import { StudyPlanDraftCard } from './StudyPlanDraftCard';
import { ScheduleCard } from './ScheduleCard';
import { GenericPreviewCard } from './GenericPreviewCard';

interface PreviewRendererProps {
  previewType: PreviewType;
  data: any;
  itemCount?: number;
  onAccept?: () => void;
  onDismiss?: () => void;
}

export function PreviewRenderer({ previewType, data, itemCount = 1, onAccept, onDismiss }: PreviewRendererProps) {
  // Layout hint available via selectLayout(previewType, itemCount)
  void selectLayout(previewType, itemCount);

  switch (previewType) {
    case 'session':
      return <SessionCard data={data} />;
    case 'assignment':
      return <AssignmentCard data={data} />;
    case 'resource':
      return <ResourceCard data={data} />;
    case 'student-progress':
      return <StudentProgressCard data={data} />;
    case 'question-draft':
      return <QuestionDraftCard data={data} onAccept={onAccept} onDismiss={onDismiss} />;
    case 'study-plan-draft':
      return <StudyPlanDraftCard data={data} onAccept={onAccept} onDismiss={onDismiss} />;
    case 'schedule':
      return <ScheduleCard data={data} />;
    default:
      return <GenericPreviewCard data={data as Record<string, unknown>} />;
  }
}
